package org.solyton.solawi.bid.module.banking.`data`.sepa.collection

import kotlin.Boolean
import kotlin.Int
import kotlin.collections.List
import kotlin.collections.Map
import org.evoleq.axioms.definition.ReadOnly
import org.evoleq.axioms.definition.ReadWrite
import org.evoleq.optics.lens.Lens
import org.solyton.solawi.bid.module.banking.`data`.BankAccountId
import org.solyton.solawi.bid.module.banking.`data`.ChargeBearer
import org.solyton.solawi.bid.module.banking.`data`.CreditorIdentifierId
import org.solyton.solawi.bid.module.banking.`data`.LocalInstrument
import org.solyton.solawi.bid.module.banking.`data`.MandateReferencePrefix
import org.solyton.solawi.bid.module.banking.`data`.PurposeCode
import org.solyton.solawi.bid.module.banking.`data`.RemittanceInformation
import org.solyton.solawi.bid.module.banking.`data`.SepaCollectionId
import org.solyton.solawi.bid.module.banking.`data`.SepaCollectionKey
import org.solyton.solawi.bid.module.banking.`data`.SepaCollectionReferenceId
import org.solyton.solawi.bid.module.banking.`data`.SepaMandateId
import org.solyton.solawi.bid.module.banking.`data`.SepaMandateReferenceId
import org.solyton.solawi.bid.module.banking.`data`.sepa.SepaSequenceType
import org.solyton.solawi.bid.module.banking.`data`.sepa.mandate.SepaMandate
import org.solyton.solawi.bid.module.banking.`data`.sepa.payment.SepaPayment

/**
 * Autogenerated ReadOnly Lens.
 * Read [SepaCollection.sepaCollectionId]
 */
@ReadOnly
public val sepaCollectionId: Lens<SepaCollection, SepaCollectionId> by lazy {
      Lens(
        get = { whole -> whole.sepaCollectionId },
        set = { { it } }
      )}


/**
 * Autogenerated Lens.
 * Read and manipulate [SepaCollection.creditorIdentifierId]
 */
@ReadWrite
public val creditorIdentifierId: Lens<SepaCollection, CreditorIdentifierId> by lazy {
      Lens(
        get = { whole -> whole.creditorIdentifierId },
        set = { part -> { whole -> whole.copy(creditorIdentifierId = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [SepaCollection.creditorIdentifierId]
 */
@ReadWrite
public
    fun SepaCollection.creditorIdentifierId(`set`: CreditorIdentifierId.() -> CreditorIdentifierId):
    SepaCollection = copy(creditorIdentifierId = set(creditorIdentifierId))

/**
 * Autogenerated Lens.
 * Read and manipulate [SepaCollection.creditorBankAccountId]
 */
@ReadWrite
public val creditorBankAccountId: Lens<SepaCollection, BankAccountId> by lazy {
      Lens(
        get = { whole -> whole.creditorBankAccountId },
        set = { part -> { whole -> whole.copy(creditorBankAccountId = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [SepaCollection.creditorBankAccountId]
 */
@ReadWrite
public fun SepaCollection.creditorBankAccountId(`set`: BankAccountId.() -> BankAccountId):
    SepaCollection = copy(creditorBankAccountId = set(creditorBankAccountId))

/**
 * Autogenerated Lens.
 * Read and manipulate [SepaCollection.mandateReferencePrefix]
 */
@ReadWrite
public val mandateReferencePrefix: Lens<SepaCollection, MandateReferencePrefix> by lazy {
      Lens(
        get = { whole -> whole.mandateReferencePrefix },
        set = { part -> { whole -> whole.copy(mandateReferencePrefix = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [SepaCollection.mandateReferencePrefix]
 */
@ReadWrite
public
    fun SepaCollection.mandateReferencePrefix(`set`: MandateReferencePrefix.() -> MandateReferencePrefix):
    SepaCollection = copy(mandateReferencePrefix = set(mandateReferencePrefix))

/**
 * Autogenerated Lens.
 * Read and manipulate [SepaCollection.collectionKey]
 */
@ReadWrite
public val collectionKey: Lens<SepaCollection, SepaCollectionKey> by lazy {
      Lens(
        get = { whole -> whole.collectionKey },
        set = { part -> { whole -> whole.copy(collectionKey = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [SepaCollection.collectionKey]
 */
@ReadWrite
public fun SepaCollection.collectionKey(`set`: SepaCollectionKey.() -> SepaCollectionKey):
    SepaCollection = copy(collectionKey = set(collectionKey))

/**
 * Autogenerated Lens.
 * Read and manipulate [SepaCollection.remittanceInformation]
 */
@ReadWrite
public val remittanceInformation: Lens<SepaCollection, RemittanceInformation> by lazy {
      Lens(
        get = { whole -> whole.remittanceInformation },
        set = { part -> { whole -> whole.copy(remittanceInformation = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [SepaCollection.remittanceInformation]
 */
@ReadWrite
public
    fun SepaCollection.remittanceInformation(`set`: RemittanceInformation.() -> RemittanceInformation):
    SepaCollection = copy(remittanceInformation = set(remittanceInformation))

/**
 * Autogenerated Lens.
 * Read and manipulate [SepaCollection.sepaSequenceType]
 */
@ReadWrite
public val sepaSequenceType: Lens<SepaCollection, SepaSequenceType> by lazy {
      Lens(
        get = { whole -> whole.sepaSequenceType },
        set = { part -> { whole -> whole.copy(sepaSequenceType = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [SepaCollection.sepaSequenceType]
 */
@ReadWrite
public fun SepaCollection.sepaSequenceType(`set`: SepaSequenceType.() -> SepaSequenceType):
    SepaCollection = copy(sepaSequenceType = set(sepaSequenceType))

/**
 * Autogenerated Lens.
 * Read and manipulate [SepaCollection.localInstrument]
 */
@ReadWrite
public val localInstrument: Lens<SepaCollection, LocalInstrument?> by lazy {
      Lens(
        get = { whole -> whole.localInstrument },
        set = { part -> { whole -> whole.copy(localInstrument = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [SepaCollection.localInstrument]
 */
@ReadWrite
public fun SepaCollection.localInstrument(`set`: LocalInstrument?.() -> LocalInstrument?):
    SepaCollection = copy(localInstrument = set(localInstrument))

/**
 * Autogenerated Lens.
 * Read and manipulate [SepaCollection.chargeBearer]
 */
@ReadWrite
public val chargeBearer: Lens<SepaCollection, ChargeBearer> by lazy {
      Lens(
        get = { whole -> whole.chargeBearer },
        set = { part -> { whole -> whole.copy(chargeBearer = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [SepaCollection.chargeBearer]
 */
@ReadWrite
public fun SepaCollection.chargeBearer(`set`: ChargeBearer.() -> ChargeBearer): SepaCollection =
    copy(chargeBearer = set(chargeBearer))

/**
 * Autogenerated Lens.
 * Read and manipulate [SepaCollection.requestedCollectionDay]
 */
@ReadWrite
public val requestedCollectionDay: Lens<SepaCollection, Int?> by lazy {
      Lens(
        get = { whole -> whole.requestedCollectionDay },
        set = { part -> { whole -> whole.copy(requestedCollectionDay = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [SepaCollection.requestedCollectionDay]
 */
@ReadWrite
public fun SepaCollection.requestedCollectionDay(`set`: Int?.() -> Int?): SepaCollection =
    copy(requestedCollectionDay = set(requestedCollectionDay))

/**
 * Autogenerated Lens.
 * Read and manipulate [SepaCollection.leadTimesDays]
 */
@ReadWrite
public val leadTimesDays: Lens<SepaCollection, Int> by lazy {
      Lens(
        get = { whole -> whole.leadTimesDays },
        set = { part -> { whole -> whole.copy(leadTimesDays = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [SepaCollection.leadTimesDays]
 */
@ReadWrite
public fun SepaCollection.leadTimesDays(`set`: Int.() -> Int): SepaCollection = copy(leadTimesDays =
    set(leadTimesDays))

/**
 * Autogenerated Lens.
 * Read and manipulate [SepaCollection.purposeCode]
 */
@ReadWrite
public val purposeCode: Lens<SepaCollection, PurposeCode?> by lazy {
      Lens(
        get = { whole -> whole.purposeCode },
        set = { part -> { whole -> whole.copy(purposeCode = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [SepaCollection.purposeCode]
 */
@ReadWrite
public fun SepaCollection.purposeCode(`set`: PurposeCode?.() -> PurposeCode?): SepaCollection =
    copy(purposeCode = set(purposeCode))

/**
 * Autogenerated Lens.
 * Read and manipulate [SepaCollection.isActive]
 */
@ReadWrite
public val isActive: Lens<SepaCollection, Boolean> by lazy {
      Lens(
        get = { whole -> whole.isActive },
        set = { part -> { whole -> whole.copy(isActive = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [SepaCollection.isActive]
 */
@ReadWrite
public fun SepaCollection.isActive(`set`: Boolean.() -> Boolean): SepaCollection = copy(isActive =
    set(isActive))

/**
 * Autogenerated Lens.
 * Read and manipulate [SepaCollection.sepaMandates]
 */
@ReadWrite
public val sepaMandates: Lens<SepaCollection, List<SepaMandate>> by lazy {
      Lens(
        get = { whole -> whole.sepaMandates },
        set = { part -> { whole -> whole.copy(sepaMandates = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [SepaCollection.sepaMandates]
 */
@ReadWrite
public fun SepaCollection.sepaMandates(`set`: List<SepaMandate>.() -> List<SepaMandate>):
    SepaCollection = copy(sepaMandates = set(sepaMandates))

/**
 * Autogenerated Lens.
 * Read and manipulate [SepaCollection.sepaPayments]
 */
@ReadWrite
public val sepaPayments: Lens<SepaCollection, List<SepaPayment>> by lazy {
      Lens(
        get = { whole -> whole.sepaPayments },
        set = { part -> { whole -> whole.copy(sepaPayments = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [SepaCollection.sepaPayments]
 */
@ReadWrite
public fun SepaCollection.sepaPayments(`set`: List<SepaPayment>.() -> List<SepaPayment>):
    SepaCollection = copy(sepaPayments = set(sepaPayments))

/**
 * Autogenerated Lens.
 * Read and manipulate [SepaCollection.referenceIds]
 */
@ReadWrite
public val referenceIds: Lens<SepaCollection, List<SepaCollectionReferenceId>> by lazy {
      Lens(
        get = { whole -> whole.referenceIds },
        set = { part -> { whole -> whole.copy(referenceIds = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [SepaCollection.referenceIds]
 */
@ReadWrite
public
    fun SepaCollection.referenceIds(`set`: List<SepaCollectionReferenceId>.() -> List<SepaCollectionReferenceId>):
    SepaCollection = copy(referenceIds = set(referenceIds))

/**
 * Autogenerated Lens.
 * Read and manipulate [SepaCollection.mandateReferenceIds]
 */
@ReadWrite
public val mandateReferenceIds:
    Lens<SepaCollection, Map<SepaMandateId, List<SepaMandateReferenceId>>> by lazy {
      Lens(
        get = { whole -> whole.mandateReferenceIds },
        set = { part -> { whole -> whole.copy(mandateReferenceIds = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [SepaCollection.mandateReferenceIds]
 */
@ReadWrite
public
    fun SepaCollection.mandateReferenceIds(`set`: Map<SepaMandateId, List<SepaMandateReferenceId>>.() -> Map<SepaMandateId, List<SepaMandateReferenceId>>):
    SepaCollection = copy(mandateReferenceIds = set(mandateReferenceIds))
